import React from "react";

// Shared pill for quote/request statuses and Defect Register states.
//
// The defect states have their own keys rather than borrowing the quote
// vocabulary, so the register does not silently change meaning if quote
// statuses are ever reworked. `rectified` takes a deeper green than
// `quote_approved` so the two do not read as the same thing at a glance.
export const STATUS_COLORS = {
  // Quote / request statuses
  draft: { bg: "#f1f5f9", color: "#64748b" },
  sent: { bg: "#eff6ff", color: "#1d4ed8" },
  approved: { bg: "#f0fdf4", color: "#16a34a" },
  rejected: { bg: "#fff1f2", color: "#e11d48" },
  pending: { bg: "#fff7ed", color: "#ea580c" },
  in_progress: { bg: "#eff6ff", color: "#1d4ed8" },
  completed: { bg: "#f0fdf4", color: "#16a34a" },
  unassigned: { bg: "#f1f5f9", color: "#64748b" },
  // Follow-Up states (in_progress / completed reuse the keys above)
  open: { bg: "#fff7ed", color: "#c2410c" },
  // Defect Register states
  reported: { bg: "#fef2f2", color: "#b91c1c" },
  quoted: { bg: "#eff6ff", color: "#1d4ed8" },
  quote_approved: { bg: "#f0fdf4", color: "#16a34a" },
  rectified: { bg: "#dcfce7", color: "#15803d" },
};

export function StatusBadge({ status, label }) {
  const s = STATUS_COLORS[status] || STATUS_COLORS.draft;
  return (
    <span
      style={{
        backgroundColor: s.bg,
        color: s.color,
        border: `1px solid ${s.color}40`,
        borderRadius: "999px",
        padding: "2px 10px",
        fontSize: "11px",
        fontWeight: "600",
        textTransform: "capitalize",
        whiteSpace: "nowrap",
      }}
    >
      {label || (status || "").replace(/_/g, " ")}
    </span>
  );
}
